import script from "./TransactionSign.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionSign.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionSign.vue?vue&type=style&index=0&id=5089a44e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5089a44e"]])

export default __exports__